import styled from 'styled-components'
import { NumericFormat } from 'react-number-format'

import FormFieldInput from '../FormFieldInput'
import { inputStyle } from '../FormFieldInput/styled'

export const InputComponent = styled(NumericFormat)`
  ${inputStyle}
`

export const Input = styled(FormFieldInput)``
